<template>
  <div>
    <h4 v-show="showTitle">Sign Up To Our Newsletter</h4>

    <div class="footer-subscribe-form">
      <form
          @submit.prevent="signUp"
          @keydown="clearFormValidationError"
          @selected="clearFormValidationError"
          novalidate
          class="subscribe-form full-width" autocomplete="off"
      >

        <div class="row set-after">
          <div class="col-six mob-full left">
            <div class="icon-input--first-name"></div>
            <input
                v-model="form.first_name"
                :disabled="request"
                type="text"
                name="first_name"
                class="first-name"
                id="first-name"
                placeholder="First Name"
                required
            />

            <ValidationMessage :errors="form.errors" propertyName="first_name"/>
          </div>

          <div class="col-six mob-full right">
            <div class="icon-input--last-name"></div>
            <input
                v-model="form.last_name"
                :disabled="request"
                type="text"
                name="last_name"
                class="last-name"
                id="last-name"
                placeholder="Last Name"
                required
            />

            <ValidationMessage :errors="form.errors" propertyName="last_name"/>
          </div>
        </div>

        <div class="row set-after">
          <div class="col-full">
            <div class="icon-input--email"></div>
            <input
                v-model="form.email"
                :disabled="request"
                type="email"
                name="email"
                class="email"
                id="email-sign-up-to-our-newsletter"
                placeholder="Email Address"
                required
            />

            <ValidationMessage :errors="form.errors" propertyName="email"/>
          </div>
        </div>

        <div class="row set-after">
          <label for="member-type">I am an...</label>
          <div class="col-six mob-full left">
            <div class="ci-custom-select">
              <select
                  v-model="form.subscriber_role_id"
                  :disabled="request"
                  class="full-width"
                  id="member-type"
                  name="subscriber_role_id"
                  required
              >
                <option v-for="role in roles" :value="role.id">{{ role.title }}</option>
              </select>

              <ValidationMessage :errors="form.errors" propertyName="subscriber_role_id"/>
            </div>
          </div>

          <div class="col-six mob-full right">
            <input :disabled="request" type="submit" name="subscribe" value="Send" class="btn btn--primary">
          </div>
        </div>

      </form>
    </div>

    <ThankYouModal
        :show="showThankYouModal"
        @close="showThankYouModal = false;"
    />
  </div>
</template>

<script>
import Form from './../../Form';
import newsletterAPI from './../../api/newsletters';
import ThankYouModal from './ThankYouModal';
import modal from './../../services/modal';
import formClearValidation from './../../mixins/form-clear-validation-mix';

export default {
  props: {
    roles: {
      required: true,
      type: Array
    },

    showTitle: {
      required: false,
      type: Boolean,
      default: () => {
        return true;
      }
    },
  },

  components: {
    ThankYouModal,
  },

  mixins: [formClearValidation],

  created() {
    this.setClearForm();
  },

  data() {
    return {
      // Init the form by created hook
      form: null,

      showThankYouModal: false,

      request: null,
    };
  },

  methods: {
    signUp() {
      this.request = newsletterAPI.signUp(this.form.data())
        .then(() => {
          this.request = null;

          this.showThankYouModal = true;
          this.setClearForm();
        })
        .catch((error) => {
          this.request = null;

          if (error.response.status === 422) {
            return this.form.onFail(error.response.data.errors);
          }

          modal.error({text: 'The sign up not completed for our newsletter successfully. Please contact the administration.'});
        });
    },


    setClearForm() {
      let defaultRole = this.roles.filter((role) => {
        return role.segment === 'illustrators';
      })[0];

      this.form = new Form({
        first_name: '',
        last_name: '',
        email: '',
        subscriber_role_id: defaultRole ? defaultRole.id : null,
      });
    },
  },
};
</script>
